import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { AuthProvider } from './auth/AuthContext.jsx';
import { msalInstance } from './auth/msalConfig.js';
import { injectTagColourStyles } from './utils/tagColors.js';
import { setBootStage, formatBootDiagnostics } from './lib/bootStage.js';
import BootErrorBoundary from './components/BootErrorBoundary.jsx';
import './styles/global.css';

function renderBootError(title, err, stageId = 'boot.error') {
  const diag = formatBootDiagnostics({ error: err, stageId, stageLabel: title });
  console.error('[boot]', diag);
  document.getElementById('root').innerHTML =
    `<div class="boot-error-page">
       <div class="boot-error-card">
         <strong class="boot-error-title">${title}</strong>
         <div class="boot-error-section">
           <div class="boot-error-kicker">Where it failed</div>
           <div class="boot-error-stage"><code>${stageId}</code><span>${title}</span></div>
         </div>
         <div class="boot-error-section">
           <div class="boot-error-kicker">Error</div>
           <pre class="boot-error-message">${err?.message || 'Unknown error'}</pre>
         </div>
         <button type="button" class="boot-error-reload" onclick="location.reload()">Reload page</button>
       </div>
     </div>`;
}

// Generate the per-colour `.tag-c-*` rules from the single palette in
// utils/tagColors.js so the allowlist Set and the CSS can't drift apart.
injectTagColourStyles();
setBootStage('boot.styles', 'Loading styles');

// MSAL must be fully initialised before any component tries to use it.
// handleRedirectPromise() processes the auth code in the URL after the
// Microsoft login redirect — if we skip this, the redirect loop never resolves.
setBootStage('msal.init', 'Initialising Microsoft sign-in');
msalInstance.initialize().then(() => {
  setBootStage('msal.redirect', 'Processing sign-in redirect');
  return msalInstance.handleRedirectPromise();
}).then(() => {
  setBootStage('react.mount', 'Starting application');
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <BootErrorBoundary stageId="app" stageLabel="Application shell">
            <App />
          </BootErrorBoundary>
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}).catch(err => {
  renderBootError('Authentication failed to initialise', err, 'msal.init');
});
